import { render } from "./ChatMessages.vue?vue&type=template&id=bbc781e4"
import script from "./ChatMessages.vue?vue&type=script&lang=ts"
export * from "./ChatMessages.vue?vue&type=script&lang=ts"

import "./ChatMessages.vue?vue&type=style&index=0&id=bbc781e4&lang=css"
script.render = render

export default script